import { createElement, append, prepend, isNullOrUndefined, getValue, getDefaultDateObject, cldrData, addClass, setStyleAttribute, formatUnit, EventHandler, remove } from '@syncfusion/ej2-base';
import * as cls from '../base/css-constant';
import * as event from '../base/constant';
import * as util from '../base/util';
/**
 * view base
 */
var ViewBase = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {Schedule} parent Accepts the schedule instance
     */
    function ViewBase(parent) {
        this.previousNextAction = 'Next';
        this.parent = parent;
    }
    ViewBase.prototype.isTimelineView = function () {
        return this.parent.currentView.indexOf('Timeline') !== -1;
    };
    ViewBase.prototype.getContentRows = function () {
        return [];
    };
    ViewBase.prototype.refreshHeader = function () {
        // Method to refresh the date header
    };
    ViewBase.prototype.refreshResourceHeader = function () {
        var resTbl = this.element.querySelector('.' + cls.RESOURCE_COLUMN_TABLE_CLASS);
        var resourceTd = Array.from(resTbl.querySelectorAll('.' + cls.RESOURCE_CELLS_CLASS));
        resourceTd.forEach(function (currentElement) {
            var children = Array.from(currentElement.children);
            children.forEach(function (child) {
                if (!child.classList.contains(cls.RESOURCE_EXPAND_CLASS) && !child.classList.contains(cls.RESOURCE_COLLAPSE_CLASS)) {
                    remove(child);
                }
            });
        });
        var rendereData = this.parent.resourceBase.renderedResources;
        if (!isNullOrUndefined(rendereData) && rendereData.length > 0) {
            for (var i = 0; i < resourceTd.length; i++) {
                var element = resourceTd[parseInt(i.toString(), 10)];
                var data = rendereData[parseInt(i.toString(), 10)];
                if (this.parent.activeView && !isNullOrUndefined(element) && !isNullOrUndefined(data)
                    && parseInt(element.getAttribute('data-group-index'), 10) === data.groupIndex) {
                    this.parent.activeView.setResourceHeaderContent(element, data, cls.RESOURCE_TEXT_CLASS);
                }
            }
        }
        this.parent.renderTemplates();
        this.parent.notify(event.contentReady, {});
    };
    ViewBase.prototype.getDayName = function (date) {
        return this.parent.getDayNames('abbreviated')[date.getDay()];
    };
    ViewBase.prototype.getDate = function (date) {
        return this.parent.globalize.formatDate(date, { format: 'd', calendar: this.parent.getCalendarMode() });
    };
    ViewBase.prototype.getTime = function (date) {
        if (this.parent.isAdaptive) {
            if (this.parent.activeViewOptions.timeFormat === 'HH:mm' || this.parent.activeViewOptions.timeFormat === 'HH.mm') {
                return this.parent.globalize.formatDate(date, { format: 'H', calendar: this.parent.getCalendarMode() });
            }
            return this.parent.globalize.formatDate(date, { skeleton: 'h', calendar: this.parent.getCalendarMode() });
        }
        return this.parent.getTimeString(date);
    };
    ViewBase.prototype.getTimelineDate = function (date) {
        var text = this.parent.globalize.formatDate(date, { skeleton: 'MMMd', calendar: this.parent.getCalendarMode() }) + ', ' +
            this.parent.getDayNames('wide')[date.getDay()];
        return util.capitalizeFirstWord(text, 'multiple');
    };
    ViewBase.prototype.createEventTable = function (trCount) {
        var eventTable = createElement('div', { className: cls.EVENT_TABLE_CLASS });
        append(this.getEventRows(trCount), eventTable);
        return eventTable;
    };
    ViewBase.prototype.getEventRows = function (trCount) {
        var eventRows = [];
        var eventContainer;
        for (var row = 0; row < trCount; row++) {
            eventContainer = createElement('div', { className: cls.APPOINTMENT_CONTAINER_CLASS });
            if (this.parent.resourceBase && !this.parent.uiStateValues.isGroupAdaptive && this.parent.resourceBase.renderedResources) {
                eventContainer.setAttribute('data-group-index', this.parent.resourceBase.renderedResources[parseInt(row.toString(), 10)].groupIndex.toString());
            }
            eventRows.push(eventContainer);
        }
        return eventRows;
    };
    ViewBase.prototype.collapseRows = function (wrap) {
        if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.uiStateValues.isGroupAdaptive) {
            this.parent.resourceBase.hideResourceRows(wrap.querySelector('tbody'));
            this.parent.resourceBase.hideResourceRows(wrap.querySelector('.' + cls.EVENT_TABLE_CLASS));
        }
    };
    ViewBase.prototype.createTableLayout = function (className) {
        var clsName = className || '';
        var table = createElement('table', { className: cls.SCHEDULE_TABLE_CLASS + ' ' + clsName });
        var tbody = createElement('tbody');
        table.appendChild(tbody);
        return table;
    };
    ViewBase.prototype.setAriaAttributes = function (table) {
        table.setAttribute('role', 'grid');
        if (this.parent.currentView !== 'Year') {
            table.setAttribute('id', this.parent.element.id + '_table');
        }
        table.setAttribute('aria-label', this.getLabelText(this.parent.currentView));
    };
    ViewBase.prototype.createColGroup = function (table, lastRow) {
        if (isNullOrUndefined(lastRow)) {
            return;
        }
        var length = lastRow.length;
        if (lastRow[0] && lastRow[0].colSpan) {
            length = lastRow.map(function (value) { return value.colSpan; }).reduce(function (prev, next) { return prev + next; });
        }
        var colGroupEle = createElement('colgroup');
        for (var i = 0; i < length; i++) {
            colGroupEle.appendChild(createElement('col'));
        }
        prepend([colGroupEle], table);
    };
    ViewBase.prototype.getScrollXIndent = function (content) {
        return content.offsetHeight - content.clientHeight > 0 ? util.getScrollBarWidth() : 0;
    };
    ViewBase.prototype.scrollTopPanel = function (target) {
        this.getDatesHeaderElement().firstElementChild.scrollLeft = target.scrollLeft;
    };
    ViewBase.prototype.scrollHeaderLabels = function (target) {
        var headerTable = this.element.querySelector('.e-date-header-wrap table');
        var colWidth = headerTable.offsetWidth / headerTable.querySelectorAll('colgroup col').length;
        var applyLeft = function (headerCells, isRtl) {
            var currentCell;
            var tdLeft = 0;
            var colSpan = 0;
            var hiddenLeft = isRtl ? -(target.scrollLeft) : target.scrollLeft;
            for (var _i = 0, headerCells_2 = headerCells; _i < headerCells_2.length; _i++) {
                var cell = headerCells_2[_i];
                colSpan += parseInt(cell.getAttribute('colSpan'), 10);
                if (colSpan > Math.floor(hiddenLeft / colWidth)) {
                    currentCell = cell;
                    break;
                }
                tdLeft += cell.offsetWidth;
            }
            if (!isNullOrUndefined(currentCell)) {
                currentCell.children[0].style[isRtl ? 'right' : 'left'] = (hiddenLeft - tdLeft) + 'px';
            }
        };
        var classNames = ['.e-header-year-cell', '.e-header-month-cell', '.e-header-week-cell', '.e-header-cells'];
        for (var _i = 0, classNames_1 = classNames; _i < classNames_1.length; _i++) {
            var className = classNames_1[_i];
            var headerCells = [].slice.call(this.element.querySelectorAll(className));
            if (headerCells.length > 0) {
                for (var _a = 0, headerCells_1 = headerCells; _a < headerCells_1.length; _a++) {
                    var element = headerCells_1[_a];
                    element.children[0].style[this.parent.enableRtl ? 'right' : 'left'] = '';
                }
                applyLeft(headerCells, this.parent.enableRtl);
            }
        }
    };
    ViewBase.prototype.addAttributes = function (td, element) {
        if (td.template) {
            append(td.template, element);
        }
        if (td.colSpan) {
            element.setAttribute('colspan', td.colSpan.toString());
        }
        if (td.className) {
            addClass([element], td.className);
        }
    };
    ViewBase.prototype.getHeaderBarHeight = function () {
        var headerBarHeight = 2;
        if (this.parent.headerModule) {
            headerBarHeight += util.getOuterHeight(this.parent.headerModule.getHeaderElement());
        }
        if (this.parent.uiStateValues.isGroupAdaptive) {
            var resHeader = this.parent.element.querySelector('.' + cls.RESOURCE_HEADER_TOOLBAR);
            if (resHeader) {
                headerBarHeight += resHeader.offsetHeight;
            }
        }
        return headerBarHeight;
    };
    ViewBase.prototype.renderPanel = function (type) {
        if (type === cls.PREVIOUS_PANEL_CLASS) {
            prepend([this.element], this.parent.element.querySelector('.' + cls.TABLE_CONTAINER_CLASS));
        }
        else {
            this.parent.element.querySelector('.' + cls.TABLE_CONTAINER_CLASS).appendChild(this.element);
        }
    };
    ViewBase.prototype.setPanel = function (panel) {
        this.element = panel;
    };
    ViewBase.prototype.getPanel = function () {
        return this.element;
    };
    ViewBase.prototype.getDatesHeaderElement = function () {
        return this.element.querySelector('.' + cls.DATE_HEADER_CONTAINER_CLASS);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ViewBase.prototype.getDateSlots = function (renderDates, workDays) {
        return []; // Here getDateSlots only need in vertical and month views
    };
    ViewBase.prototype.generateColumnLevels = function () {
        return []; // Here generateColumnLevels only need in vertical and month views
    };
    ViewBase.prototype.getColumnLevels = function () {
        return this.colLevels;
    };
    ViewBase.prototype.highlightCurrentTime = function () {
        // Here showTimeIndicator functionalities
    };
    ViewBase.prototype.getStartDate = function () {
        return this.renderDates[0];
    };
    ViewBase.prototype.getEndDate = function () {
        return this.renderDates[this.renderDates.length - 1];
    };
    ViewBase.prototype.startDate = function () {
        return this.renderDates[0];
    };
    ViewBase.prototype.endDate = function () {
        return util.addDays(this.renderDates[this.renderDates.length - 1], 1);
    };
    ViewBase.prototype.getStartHour = function () {
        var startHour = this.parent.getStartEndTime(this.parent.activeViewOptions.startHour);
        if (isNullOrUndefined(startHour)) {
            startHour = new Date(2000, 0, 0, 0);
        }
        return startHour;
    };
    ViewBase.prototype.getEndHour = function () {
        var endHour = this.parent.getStartEndTime(this.parent.activeViewOptions.endHour);
        if (isNullOrUndefined(endHour)) {
            endHour = new Date(2000, 0, 0, 0);
        }
        return endHour;
    };
    ViewBase.prototype.isCurrentDate = function (date) {
        return date.setHours(0, 0, 0, 0) === new Date(this.parent.currentTimezoneDate).setHours(0, 0, 0, 0);
    };
    ViewBase.prototype.isCurrentMonth = function (date) {
        if (this.parent.activeViewOptions.displayDate || this.parent.activeViewOptions.numberOfWeeks > 0) {
            return this.parent.activeView.getStartDate().getTime() <= this.parent.getCurrentTime().getTime() &&
                this.parent.activeView.getEndDate().getTime() >= this.parent.getCurrentTime().getTime();
        }
        return date.getFullYear() ===
            this.parent.getCurrentTime().getFullYear() && date.getMonth() === this.parent.getCurrentTime().getMonth();
    };
    ViewBase.prototype.isWorkDay = function (date, workDays) {
        if (workDays === void 0) { workDays = this.parent.activeViewOptions.workDays; }
        if (!isNullOrUndefined(workDays) && workDays.indexOf(date.getDay()) >= 0) {
            return true;
        }
        return false;
    };
    ViewBase.prototype.isWorkHour = function (date, startHour, endHour, workDays) {
        if (isNullOrUndefined(startHour) || isNullOrUndefined(endHour)) {
            return false;
        }
        startHour.setMilliseconds(0);
        endHour.setMilliseconds(0);
        if (util.resetTime(date).getTime() !== util.resetTime(startHour).getTime()) {
            startHour = new Date(2000, 0, 0, startHour.getHours(), startHour.getMinutes(), startHour.getMilliseconds());
            endHour = new Date(2000, 0, 0, endHour.getHours(), endHour.getMinutes(), endHour.getMilliseconds());
        }
        return !(util.getDateInMs(date) < util.getDateInMs(startHour) || util.getDateInMs(date) >= util.getDateInMs(endHour) ||
            !this.isWorkDay(date, workDays));
    };
    ViewBase.prototype.getRenderDates = function (workDays, date) {
        if (date === void 0) { date = this.parent.selectedDate; }
        var renderDates = [];
        // Due to same code for vertical and time line, week & work week views, if condition has used
        if (this.parent.currentView === 'Week' || this.parent.currentView === 'TimelineWeek') {
            var selectedDate = util.resetTime(date);
            var start = util.getWeekFirstDate(selectedDate, this.parent.activeViewOptions.firstDayOfWeek);
            for (var i = 0, length_1 = util.WEEK_LENGTH * this.parent.activeViewOptions.interval; i < length_1; i++) {
                if (this.parent.activeViewOptions.showWeekend) {
                    renderDates.push(start);
                }
                else {
                    if (this.isWorkDay(start, workDays)) {
                        renderDates.push(start);
                    }
                }
                start = util.addDays(start, 1);
            }
        }
        else if (this.parent.currentView === 'WorkWeek' || this.parent.currentView === 'TimelineWorkWeek') {
            var start = util.getWeekFirstDate(util.resetTime(date), this.parent.activeViewOptions.firstDayOfWeek);
            for (var i = 0, length_2 = util.WEEK_LENGTH * this.parent.activeViewOptions.interval; i < length_2; i++) {
                if (this.isWorkDay(start, workDays)) {
                    renderDates.push(start);
                }
                start = util.addDays(start, 1);
            }
        }
        else {
            var dayCount = this.parent.currentView === 'Agenda' ? this.parent.agendaDaysCount :
                this.parent.activeViewOptions.interval;
            var start = util.resetTime(date);
            do {
                if (this.parent.activeViewOptions.showWeekend) {
                    renderDates.push(start);
                }
                else {
                    if (this.isWorkDay(start, workDays)) {
                        renderDates.push(start);
                    }
                }
                start = util.addDays(start, 1);
            } while (dayCount !== renderDates.length);
        }
        if (!workDays) {
            this.renderDates = renderDates;
        }
        if (this.parent.headerModule) {
            this.parent.headerModule.previousNextIconHandler();
        }
        return renderDates;
    };
    ViewBase.prototype.getNextPreviousDate = function (type) {
        this.previousNextAction = type;
        if (this.parent.currentView === 'Day' || this.parent.currentView === 'TimelineDay') {
            if (this.parent.activeViewOptions.showWeekend) {
                var daysCount = this.parent.activeViewOptions.interval;
                return util.addDays(this.parent.selectedDate, type === 'Next' ? daysCount : -daysCount);
            }
            else {
                var date = void 0;
                if (type === 'Next') {
                    date = util.addDays(this.renderDates.slice(-1)[0], 1);
                    while (!this.isWorkDay(date)) {
                        date = util.addDays(date, 1);
                    }
                }
                else {
                    date = util.addDays(this.renderDates[0], -1);
                    var count = 0;
                    do {
                        if (this.isWorkDay(date)) {
                            count += 1;
                        }
                        if (this.parent.activeViewOptions.interval !== count) {
                            date = util.addDays(date, -1);
                        }
                    } while (this.parent.activeViewOptions.interval !== count);
                }
                return date;
            }
        }
        var weekLength = type === 'Next' ? util.WEEK_LENGTH : -util.WEEK_LENGTH;
        return util.addDays(this.parent.selectedDate, weekLength * this.parent.activeViewOptions.interval);
    };
    ViewBase.prototype.formatViewLabel = function (view, startDate, endDate) {
        var formatOptions = { type: 'date', skeleton: 'full', calendar: this.parent.getCalendarMode() };
        return this.parent.localeObj.getConstant(view) + ' ' + this.parent.localeObj.getConstant('start') + ' ' + this.parent.globalize.formatDate(startDate, formatOptions) + ' '
            + this.parent.localeObj.getConstant('endAt') + ' ' + this.parent.globalize.formatDate(endDate, formatOptions);
    };
    ViewBase.prototype.getLabelText = function (view) {
        var viewStr = view.charAt(0).toLowerCase() + view.substring(1);
        if (view === 'Year' || view === 'TimelineYear') {
            return this.formatViewLabel(viewStr, this.parent.activeView.getStartDate(), this.parent.activeView.getEndDate());
        }
        else {
            if (this.renderDates.length > 0) {
                if (this.parent.currentView === 'Day' || this.parent.currentView === 'TimelineDay') {
                    return this.parent.localeObj.getConstant(viewStr) + ' of ' + util.capitalizeFirstWord(this.parent.globalize.formatDate(this.parent.selectedDate, { type: 'date', skeleton: 'full', calendar: this.parent.getCalendarMode() }), 'single');
                }
                else {
                    return this.formatViewLabel(viewStr, this.renderDates[0], this.renderDates[this.renderDates.length - 1]);
                }
            }
            else {
                return '';
            }
        }
    };
    ViewBase.prototype.getDateRangeText = function (date, dateCollection) {
        if (date === void 0) { date = this.renderDates[0]; }
        if (dateCollection === void 0) { dateCollection = this.renderDates; }
        if (this.parent.isAdaptive) {
            var formatDate = (this.parent.activeViewOptions.dateFormat) ? this.parent.activeViewOptions.dateFormat : 'MMMM y';
            return util.capitalizeFirstWord(this.parent.globalize.formatDate(this.parent.selectedDate, { format: formatDate, calendar: this.parent.getCalendarMode() }), 'single');
        }
        return this.formatDateRange(date, dateCollection[dateCollection.length - 1]);
    };
    ViewBase.prototype.formatDateRange = function (startDate, endDate) {
        var globalize = this.parent.globalize;
        var mode = this.parent.getCalendarMode();
        if (startDate === endDate) {
            endDate = null;
        }
        if (!isNullOrUndefined(this.parent.activeViewOptions.dateFormat)) {
            var text = '';
            if (!endDate) {
                text = globalize.formatDate(startDate, { format: this.parent.activeViewOptions.dateFormat, calendar: mode });
                return util.capitalizeFirstWord(text, 'multiple');
            }
            text = (globalize.formatDate(startDate, { format: this.parent.activeViewOptions.dateFormat, calendar: mode }) +
                ' - ' + globalize.formatDate(endDate, { format: this.parent.activeViewOptions.dateFormat, calendar: mode }));
            return util.capitalizeFirstWord(text, 'multiple');
        }
        var formattedStr;
        var longDateFormat;
        if (isNullOrUndefined(this.parent.locale) || this.parent.locale === 'en' || this.parent.locale === 'en-US') {
            longDateFormat = getValue('dateFormats.long', getDefaultDateObject(mode));
        }
        else {
            longDateFormat = getValue('main.' + '' + this.parent.locale + '.dates.calendars.' + mode + '.dateFormats.long', cldrData);
        }
        if (!endDate) {
            return util.capitalizeFirstWord(globalize.formatDate(startDate, { format: longDateFormat, calendar: mode }), 'single');
        }
        var dateFormat = longDateFormat.trim().toLocaleLowerCase();
        if (dateFormat.substr(0, 1) === 'd') {
            if (startDate.getFullYear() === endDate.getFullYear()) {
                if (startDate.getMonth() === endDate.getMonth()) {
                    formattedStr = globalize.formatDate(startDate, { format: 'dd', calendar: mode }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd MMMM yyyy', calendar: mode });
                }
                else {
                    formattedStr = globalize.formatDate(startDate, { format: 'dd MMM', calendar: mode }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd MMM yyyy', calendar: mode });
                }
            }
            else {
                formattedStr = globalize.formatDate(startDate, { format: 'dd MMM yyyy', calendar: mode }) + ' - ' +
                    globalize.formatDate(endDate, { format: 'dd MMM yyyy', calendar: mode });
            }
        }
        else if (dateFormat.substr(0, 1) === 'm') {
            if (startDate.getFullYear() === endDate.getFullYear()) {
                if (startDate.getMonth() === endDate.getMonth()) {
                    formattedStr = globalize.formatDate(startDate, { format: 'MMMM dd', calendar: mode }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'dd, yyyy', calendar: mode });
                }
                else {
                    formattedStr = globalize.formatDate(startDate, { format: 'MMM dd', calendar: mode }) + ' - ' +
                        globalize.formatDate(endDate, { format: 'MMM dd, yyyy', calendar: mode });
                }
            }
            else {
                formattedStr = globalize.
                    formatDate(startDate, { format: 'MMM dd, yyyy', calendar: mode }) + ' - ' +
                    globalize.formatDate(endDate, { format: 'MMM dd, yyyy', calendar: mode });
            }
        }
        else {
            formattedStr = globalize.formatDate(startDate, { format: longDateFormat, calendar: mode }) + ' - ' +
                globalize.formatDate(endDate, { format: longDateFormat, calendar: mode });
        }
        return util.capitalizeFirstWord(formattedStr, 'multiple');
    };
    ViewBase.prototype.getMobileDateElement = function (date, className) {
        var wrap = createElement('div', {
            className: className,
            innerHTML: '<div class="e-m-date">' + this.parent.globalize.formatDate(date, { format: 'd', calendar: this.parent.getCalendarMode() }) + '</div>' + '<div class="e-m-day">' +
                util.capitalizeFirstWord(this.parent.globalize.formatDate(date, { format: 'E', calendar: this.parent.getCalendarMode() }), 'single') + '</div>'
        });
        return wrap;
    };
    ViewBase.prototype.setResourceHeaderContent = function (tdElement, tdData, className) {
        if (className === void 0) { className = cls.TEXT_ELLIPSIS; }
        if (this.parent.activeViewOptions.resourceHeaderTemplate) {
            var data = { resource: tdData.resource, resourceData: tdData.resourceData };
            var scheduleId = this.parent.element.id + '_';
            var viewName = this.parent.activeViewOptions.resourceHeaderTemplateName;
            var templateId = scheduleId + viewName + 'resourceHeaderTemplate';
            var quickTemplate = [].slice.call(this.parent.getResourceHeaderTemplate()(data, this.parent, 'resourceHeaderTemplate', templateId, false, undefined, undefined, this.parent.root));
            append(quickTemplate, tdElement);
        }
        else {
            var resourceText = createElement('div', { className: className });
            this.parent.sanitize(tdData.resourceData[tdData.resource.textField], resourceText);
            tdElement.appendChild(resourceText);
        }
    };
    ViewBase.prototype.renderResourceMobileLayout = function () {
        if (this.parent.resourceBase.lastResourceLevel && this.parent.resourceBase.lastResourceLevel.length <= 0) {
            return;
        }
        this.parent.resourceBase.renderResourceHeader();
        this.parent.resourceBase.renderResourceTree();
    };
    ViewBase.prototype.addAutoHeightClass = function (element) {
        if (!this.parent.uiStateValues.isGroupAdaptive && this.parent.rowAutoHeight && this.isTimelineView()
            && this.parent.activeViewOptions.group.resources.length > 0) {
            addClass([element], cls.AUTO_HEIGHT);
        }
    };
    ViewBase.prototype.getColElements = function () {
        return [].slice.call(this.element.querySelectorAll('.' + cls.CONTENT_WRAP_CLASS + ' col, .' + cls.DATE_HEADER_WRAP_CLASS + ' col'));
    };
    ViewBase.prototype.setColWidth = function (content) {
        if (this.isTimelineView()) {
            var colElements = this.getColElements();
            var contentBody = this.element.querySelector('.' + cls.CONTENT_TABLE_CLASS + ' tbody');
            var colWidth_1 = (this.parent.getElementWidth(contentBody) / (colElements.length / 2));
            if (content.offsetHeight !== content.clientHeight) {
                var resourceColumn = this.parent.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
                if (!isNullOrUndefined(resourceColumn) && resourceColumn.offsetHeight !== content.clientHeight) {
                    setStyleAttribute(resourceColumn, { 'height': formatUnit(content.clientHeight) });
                }
            }
            var cssClass = "." + cls.HEADER_CELLS_CLASS + ",." + cls.TIME_SLOT_CLASS + ",." + cls.HEADER_WEEK_CELLS_CLASS + ",." + cls.HEADER_MONTH_CELLS_CLASS + ",." + cls.HEADER_YEAR_CELLS_CLASS;
            var headerCellElements = [].slice.call(this.element.querySelectorAll(cssClass));
            headerCellElements.forEach(function (ele) {
                var colSpan = isNullOrUndefined(ele.getAttribute('colspan')) ? '1' : ele.getAttribute('colspan');
                var headerCellColSpan = parseInt(colSpan, 10);
                setStyleAttribute(ele, { 'width': formatUnit(colWidth_1 * headerCellColSpan) });
            });
        }
    };
    ViewBase.prototype.resetColWidth = function () {
        var colElements = this.getColElements();
        for (var _i = 0, colElements_1 = colElements; _i < colElements_1.length; _i++) {
            var col = colElements_1[_i];
            col.style.width = '';
        }
    };
    ViewBase.prototype.getContentAreaElement = function () {
        return this.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
    };
    ViewBase.prototype.wireExpandCollapseIconEvents = function () {
        if (this.parent.resourceBase && this.parent.resourceBase.resourceCollection.length > 1) {
            var treeIcons = [].slice.call(this.element.querySelectorAll('.' + cls.RESOURCE_TREE_ICON_CLASS));
            for (var _i = 0, treeIcons_1 = treeIcons; _i < treeIcons_1.length; _i++) {
                var icon = treeIcons_1[_i];
                EventHandler.clearEvents(icon);
                EventHandler.add(icon, 'click', this.parent.resourceBase.onTreeIconClick, this.parent.resourceBase);
            }
        }
    };
    ViewBase.prototype.scrollToDate = function (scrollDate) {
        if (['Month', 'TimelineMonth'].indexOf(this.parent.currentView) === -1 || isNullOrUndefined(scrollDate)) {
            return;
        }
        var scrollWrap = this.getContentAreaElement();
        var tdDate = new Date(util.resetTime(new Date(+scrollDate)).getTime()).getTime();
        var dateElement = scrollWrap.querySelector("." + cls.WORK_CELLS_CLASS + "[data-date=\"" + tdDate + "\"]");
        if (this.parent.currentView === 'Month' && dateElement) {
            if (scrollWrap.scrollWidth > scrollWrap.clientWidth) {
                if (!this.parent.enableRtl) {
                    scrollWrap.scrollLeft = dateElement.offsetLeft;
                }
                else {
                    scrollWrap.scrollLeft = -(this.parent.getContentTable().offsetWidth - dateElement.offsetLeft - dateElement.offsetWidth);
                }
            }
            scrollWrap.scrollTop = dateElement.offsetTop;
        }
        if (this.parent.currentView === 'TimelineMonth' && dateElement) {
            if (!this.parent.enableRtl) {
                scrollWrap.scrollLeft = dateElement.offsetLeft;
            }
            else {
                scrollWrap.scrollLeft = -(this.parent.getContentTable().offsetWidth - dateElement.offsetLeft - dateElement.offsetWidth);
            }
        }
    };
    ViewBase.prototype.setPersistence = function () {
        if (this.parent.enablePersistence) {
            var contentWrap = this.element.querySelector('.e-content-wrap');
            if (!isNullOrUndefined(contentWrap)) {
                this.parent.scrollLeft = contentWrap.scrollLeft;
                this.parent.scrollTop = contentWrap.scrollTop;
            }
        }
    };
    ViewBase.prototype.retainScrollPosition = function () {
        if (this.parent.enablePersistence) {
            var conWrap = this.parent.element.querySelector('.e-content-wrap');
            if (!isNullOrUndefined(conWrap) && !isNullOrUndefined(this.parent.scrollLeft) && !isNullOrUndefined(this.parent.scrollTop)) {
                conWrap.scrollTop = this.parent.scrollTop;
                conWrap.scrollLeft = this.parent.scrollLeft;
            }
        }
    };
    ViewBase.prototype.getViewStartDate = function () {
        var startDate = this.renderDates[0];
        if (this.parent.activeViewOptions.group.resources.length > 0 && this.parent.resourceBase.lastResourceLevel.length > 0) {
            startDate = this.parent.resourceBase.getResourceRenderDates()[0];
        }
        return startDate;
    };
    ViewBase.prototype.getViewEndDate = function () {
        var endDate = util.addDays(this.renderDates[this.renderDates.length - 1], 1);
        if (this.parent.activeViewOptions.group.resources.length > 0 && this.parent.resourceBase.lastResourceLevel.length > 0) {
            endDate = util.addDays(this.parent.resourceBase.getResourceRenderDates().slice(-1)[0], 1);
        }
        return endDate;
    };
    ViewBase.prototype.getAdjustedDate = function (startTime) {
        if (!this.parent.activeViewOptions.timeScale.enable || this.parent.currentView === 'Month' ||
            (this.parent.currentView === 'TimelineYear' && this.parent.activeViewOptions.group.resources.length === 0)) {
            return new Date(startTime.setHours(0, 0, 0, 0));
        }
        else if (this.parent.currentView === 'TimelineYear' && this.parent.activeViewOptions.group.resources.length > 0) {
            startTime.setHours(0, 0, 0, 0);
            return new Date(startTime.setDate(1));
        }
        return null;
    };
    ViewBase.prototype.resetColLevels = function () {
        this.parent.resourceBase.expandedResources = [];
        var renderedCount = this.parent.virtualScrollModule.getRenderedCount();
        var lastLevel = this.parent.activeViewOptions.group.byDate ? this.colLevels[0] :
            this.parent.resourceBase.renderedResources;
        var index = 0;
        for (var i = 0; i < lastLevel.length; i++) {
            if (index >= renderedCount) {
                break;
            }
            index += lastLevel[parseInt(i.toString(), 10)].colSpan;
            this.parent.resourceBase.expandedResources.push(lastLevel[parseInt(i.toString(), 10)]);
        }
        if (this.parent.activeViewOptions.group.byDate) {
            this.colLevels[0] = this.parent.resourceBase.expandedResources;
            this.parent.virtualScrollModule.setRenderedDates(this.parent.resourceBase.expandedResources);
        }
        else {
            this.colLevels[this.colLevels.length - 2] = this.parent.resourceBase.expandedResources;
            this.parent.resourceBase.renderedResources = this.parent.resourceBase.expandedResources;
        }
        if (this.parent.currentView !== 'Month') {
            this.colLevels[this.colLevels.length - 1] = this.colLevels[this.colLevels.length - 1].slice(0, index);
            this.parent.resourceBase.expandedResources = this.colLevels[this.colLevels.length - 1];
        }
    };
    ViewBase.prototype.getGroupIndices = function (dataCollection) {
        var groupIndices = [];
        if (this.parent.virtualScrollModule && this.parent.activeViewOptions.group.resources.length > 0 && (dataCollection ||
            this.parent.virtualScrollModule.existingDataCollection.length > 0) && !this.parent.uiStateValues.isGroupAdaptive) {
            dataCollection = isNullOrUndefined(dataCollection) ? this.parent.virtualScrollModule.existingDataCollection : dataCollection;
            groupIndices = dataCollection.map(function (data) { return data.groupIndex; });
        }
        return groupIndices;
    };
    ViewBase.prototype.destroy = function () {
        if (this.element && this.element.parentNode) {
            remove(this.element);
        }
        this.element = null;
        this.renderDates = null;
        this.colLevels = null;
    };
    return ViewBase;
}());
export { ViewBase };
